<div class="modal-header">
  <h4 class="modal-title">{{ 'copySchedule.title' | translate }}</h4>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="schedule-info mb-5">
    <div class="fw-semibold text-gray-600 fs-7">{{ 'copySchedule.copying' | translate }}:</div>
    <div class="fw-bold fs-5">{{ schedule.schedule_name }}</div>
    <div class="text-muted fs-7">{{ 'copySchedule.from' | translate }} {{ eventClass.class_name }}</div>
  </div>

  @if (error) {
    <div class="alert alert-danger mb-5">{{ error }}</div>
  }

  @if (loading) {
    <div class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
      </div>
    </div>
  } @else {
    <div class="fw-semibold text-gray-600 mb-3">{{ 'copySchedule.selectTargetClasses' | translate }}:</div>
    <div class="info-note mb-3">
      <i class="fa fa-info-circle me-2"></i>
      {{ 'copySchedule.copyNote' | translate }}
    </div>

    @if (dayGroups.length === 0) {
      <div class="text-center text-muted py-5">
        <i class="fa fa-calendar-xmark fs-3x mb-3 d-block opacity-50"></i>
        <p>{{ 'copySchedule.noClasses' | translate }}</p>
      </div>
    } @else {
      <div class="day-groups">
        @for (group of dayGroups; track group.dayLabel) {
          <div class="day-group">
            <div class="day-header" [class.same-day]="group.isSameDay">
              <i class="fa fa-calendar me-2"></i>
              {{ group.dayLabel }}
              @if (group.isSameDay) {
                <span class="same-day-badge">{{ 'copySchedule.currentDay' | translate }}</span>
              }
            </div>
            <div class="target-grid">
              @for (option of group.options; track option.eventClass.event_class_id) {
                <div class="target-option"
                     [class.selected]="isTargetSelected(option)"
                     [class.same-class]="option.isSameClass"
                     (click)="toggleTarget(option)">
                  <div class="target-checkbox">
                    @if (isTargetSelected(option)) {
                      <i class="fa fa-check"></i>
                    }
                  </div>
                  <div class="target-info">
                    <div class="target-class">
                      {{ option.eventClass.class_name }}
                      @if (option.isSameClass) {
                        <span class="same-class-badge">{{ 'copySchedule.current' | translate }}</span>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()">{{ 'common.cancel' | translate }}</button>
  <button type="button"
          class="btn btn-primary"
          [disabled]="copying || selectedTargets.length === 0"
          (click)="copySchedule()">
    @if (copying) {
      <span class="spinner-border spinner-border-sm me-2"></span>
      {{ 'copySchedule.copying' | translate }}...
    } @else {
      <i class="fa fa-copy me-2"></i>
      {{ 'copySchedule.copy' | translate }}
    }
  </button>
</div>
